import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  EDUCATION_PLACE,
  EDUCATION_PLACE_ALL,
  EDUCATION_PLACE_CREATE,
  EDUCATION_PLACE_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const educationPlacesSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const educationPlaceSelector = createSelector(educationPlacesSelector, data => data[EDUCATION_PLACE])

export const educationPlaceAllSelector = createSelector(educationPlacesSelector, data => data[EDUCATION_PLACE_ALL])

export const educationPlaceCreateSelector = createSelector(
  educationPlacesSelector,
  data => data[EDUCATION_PLACE_CREATE]
)

export const educationPlaceListSelector = createSelector(educationPlacesSelector, data => data[EDUCATION_PLACE_LIST])
